// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Avatars-styles--root--TdobI {
  margin: 0 -15px -15px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Avatars-styles--root--TdobI {
    margin: 0 -25px -20px;
}
  }

.src-containers-Profile-Avatars-styles--group--VgI6K,
.src-containers-Profile-Avatars-styles--button--P86Eg {
  box-sizing: border-box;
  display: block;
  border: 0;
  outline: 0;
  margin: 0;
  margin: initial;
  padding: 13px 25px 15px;
  width: 100%;
  background-color: transparent;
  color: #262626;
  color: var(--mainForeground);
  font-size: 13px;
  text-align: left;
}

@media screen and (max-width: 767.98px) {

.src-containers-Profile-Avatars-styles--group--VgI6K,
.src-containers-Profile-Avatars-styles--button--P86Eg {
    padding: 13px 15px 15px;
}
  }

.src-containers-Profile-Avatars-styles--group--VgI6K {
  padding-top: 0;
}

.src-containers-Profile-Avatars-styles--button--P86Eg {
  position: relative;
}

.src-containers-Profile-Avatars-styles--button--P86Eg input[type='file'] {
    position: absolute;
    visibility: hidden;
  }

.src-containers-Profile-Avatars-styles--group--VgI6K + .src-containers-Profile-Avatars-styles--button--P86Eg,
.src-containers-Profile-Avatars-styles--button--P86Eg + .src-containers-Profile-Avatars-styles--button--P86Eg {
  border-top: 1px solid #cfd8e2;
}

.src-containers-Profile-Avatars-styles--button--P86Eg:hover,
.src-containers-Profile-Avatars-styles--button--P86Eg:focus {
  background-color: #f3f4f7;
  cursor: pointer;
}

.src-containers-Profile-Avatars-styles--list--IFQVW {
  margin-top: 5px;
  margin-right: -10px;
  max-width: 300px;
}

.src-containers-Profile-Avatars-styles--item--YvZCM {
  position: relative;
  display: inline-block;
  margin-top: 10px;
  margin-right: 10px;
}

.src-containers-Profile-Avatars-styles--avatar--TkRrd {
  cursor: pointer !important;
}

.src-containers-Profile-Avatars-styles--delete--Zag2g {
  position: absolute !important;
  top: -5px;
  right: -5px;
  visibility: hidden;
}

.src-containers-Profile-Avatars-styles--delete--Zag2g.src-containers-Profile-Avatars-styles--visible--vgOCr {
    visibility: visible;
  }

@media screen and (max-width: 767.98px) {
    .src-containers-Profile-Avatars-styles--list--IFQVW .src-containers-Profile-Avatars-styles--delete--Zag2g > span {
      height: 1em !important;
    }
  }

.src-containers-Profile-Avatars-styles--item--YvZCM:hover .src-containers-Profile-Avatars-styles--delete--Zag2g,
.src-containers-Profile-Avatars-styles--item--YvZCM:focus .src-containers-Profile-Avatars-styles--delete--Zag2g {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Avatars/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,qBAAqB;AAKvB;;AAHE;;AAHF;IAII,qBAAqB;AAEzB;EADE;;AAGF;;EAEE,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,UAAU;EACV,SAAe;EAAf,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,cAA4B;EAA5B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAKlB;;AAHE;;AAdF;;IAeI,uBAAuB;AAE3B;EADE;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AAMpB;;AAJE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,kBAAkB;AAKpB;;AAHE;IACE,mBAAmB;EACrB;;AAIA;IACE;MACE,sBAAsB;IACxB;EACF;;AAGF;;EAEE,mBAAmB;AACrB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  margin: 0 -15px -15px;\n\n  @media (--desktop) {\n    margin: 0 -25px -20px;\n  }\n}\n\n.group,\n.button {\n  box-sizing: border-box;\n  display: block;\n  border: 0;\n  outline: 0;\n  margin: initial;\n  padding: 13px 25px 15px;\n  width: 100%;\n  background-color: transparent;\n  color: var(--mainForeground);\n  font-size: 13px;\n  text-align: left;\n\n  @media (--mobile) {\n    padding: 13px 15px 15px;\n  }\n}\n\n.group {\n  padding-top: 0;\n}\n\n.button {\n  position: relative;\n\n  & input[type='file'] {\n    position: absolute;\n    visibility: hidden;\n  }\n}\n\n.group + .button,\n.button + .button {\n  border-top: 1px solid #cfd8e2;\n}\n\n.button:hover,\n.button:focus {\n  background-color: #f3f4f7;\n  cursor: pointer;\n}\n\n.list {\n  margin-top: 5px;\n  margin-right: -10px;\n  max-width: 300px;\n}\n\n.item {\n  position: relative;\n  display: inline-block;\n  margin-top: 10px;\n  margin-right: 10px;\n}\n\n.avatar {\n  cursor: pointer !important;\n}\n\n.delete {\n  position: absolute !important;\n  top: -5px;\n  right: -5px;\n  visibility: hidden;\n\n  &.visible {\n    visibility: visible;\n  }\n}\n\n.list .delete {\n  @media (--mobile) {\n    & > span {\n      height: 1em !important;\n    }\n  }\n}\n\n.item:hover .delete,\n.item:focus .delete {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-containers-Profile-Avatars-styles--root--TdobI`,
	"group": `src-containers-Profile-Avatars-styles--group--VgI6K`,
	"button": `src-containers-Profile-Avatars-styles--button--P86Eg`,
	"list": `src-containers-Profile-Avatars-styles--list--IFQVW`,
	"item": `src-containers-Profile-Avatars-styles--item--YvZCM`,
	"avatar": `src-containers-Profile-Avatars-styles--avatar--TkRrd`,
	"delete": `src-containers-Profile-Avatars-styles--delete--Zag2g`,
	"visible": `src-containers-Profile-Avatars-styles--visible--vgOCr`
};
module.exports = ___CSS_LOADER_EXPORT___;
